"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var moment_1 = __importDefault(require("moment"));
var book_drive_controller_1 = __importDefault(require("./book-drive.controller"));
var book_drive_html_1 = __importDefault(require("./book-drive.html"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider
        .state('drivecoach.student.drives.create', {
        url: '/create/:id',
        template: book_drive_html_1.default,
        controller: book_drive_controller_1.default,
        controllerAs: 'vm',
        resolve: {
            drive: getDrive,
            locations: getLocations
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.owner,
                USER_ROLES.student
            ]
        }
    });
}
config.$inject = ['$stateProvider', '$urlRouterProvider', 'USER_ROLES'];
function getLocations($stateParams, UsersModel) {
    return UsersModel.getStudentPickupLocationsByDriveSession($stateParams.id).then(function (response) {
        response.pickuplocations.map(function (location) {
            location.name = location.name + ' ' + location.address.street;
            return location;
        });
        response.dropofflocations.map(function (location) {
            location.name = location.name + ' ' + location.address.street;
            return location;
        });
        return response;
    });
}
getLocations.$inject = ['$stateParams', 'UsersModel'];
function getDrive($stateParams, DrivesModel) {
    return DrivesModel.getDriveByID($stateParams.id).then(function (response) {
        response.drive.start_time = (0, moment_1.default)(response.drive.start_time, 'HH:mm:s').format('h:mm a');
        var minutes = moment_1.default.duration(response.drive.session_length, 'minutes');
        response.drive.end_time = (0, moment_1.default)(response.drive.start_time, 'h:mm a').add(minutes, 'minutes').format('h:mm a');
        // @todo this is a hack for a bug fix
        if (!response.drive.type.allow_custom_dropoff_locations === false && !response.drive.dropofflocation) {
            response.drive.dropofflocation = response.drive.location;
        }
        if (!response.drive.type.allow_custom_pickup_locations === false && !response.drive.pickuplocation) {
            response.drive.dropofflocation = response.drive.location;
        }
        return response.drive;
    });
}
getDrive.$inject = ['$stateParams', 'DrivesModel'];
exports.default = angular_1.default.module('student.drives.create', [])
    .controller('StudentDrivesClaimController', book_drive_controller_1.default)
    .config(config);
